<div class="agent-runs-container">

  @if (IsInitializing) {
    <div class="loading-overlay"><div class="spinner"></div> Loading...</div>
  }

  @if (!IsInitializing && !IsAuthorizedUser) {
    <div class="empty-state">
      <i class="fa-solid fa-lock"></i>
      <p>Access restricted to system administrators.</p>
    </div>
  }

  @if (IsAuthorizedUser) {

    <!-- Search Section -->
    <div class="search-section">
      <div class="search-row">
        <div class="search-input-group">
          <i class="fa-solid fa-magnifying-glass search-icon"></i>
          <input type="text" class="input-search" [(ngModel)]="RunIDSearch"
                 placeholder="Search by Run ID, Conversation Detail ID, or External ID..."
                 (keydown)="$event.key === 'Enter' ? SearchByRunID() : $event.stopPropagation()"
                 (keypress)="$event.stopPropagation()"
                 (keyup)="$event.stopPropagation()" />
          <button class="btn-search" (click)="SearchByRunID()" [disabled]="!RunIDSearch.trim()">
            Search
          </button>
        </div>
        <div class="search-input-group">
          <i class="fa-solid fa-link search-icon"></i>
          <input type="text" class="input-search" [(ngModel)]="ExtRefIDSearch"
                 placeholder="Search by External Reference ID..."
                 (keydown)="$event.key === 'Enter' ? SearchByExternalRefID() : $event.stopPropagation()"
                 (keypress)="$event.stopPropagation()"
                 (keyup)="$event.stopPropagation()" />
          <button class="btn-search" (click)="SearchByExternalRefID()" [disabled]="!ExtRefIDSearch.trim()">
            Search
          </button>
        </div>
      </div>
    </div>

    <!-- Filter Bar -->
    <div class="filter-bar">
      <div class="filter-row">
        <div class="filter-group">
          <label class="filter-label">Time Range</label>
          <div class="btn-group">
            @for (p of TimePresets; track p) {
              <button class="btn-filter" [class.active]="TimePreset === p"
                      (click)="SetTimePreset(p)">{{ p === 'custom' ? 'Custom' : p === 'all-time' ? 'All Time' : p }}</button>
            }
          </div>
          @if (TimePreset === 'custom') {
            <div class="custom-range">
              <input type="date" [(ngModel)]="CustomStartDate" />
              <span class="custom-range-sep">to</span>
              <input type="date" [(ngModel)]="CustomEndDate" />
              <button class="btn-apply" (click)="ApplyCustomRange()">Apply</button>
            </div>
          }
        </div>

        <div class="filter-group">
          <label class="filter-label">Status</label>
          <div class="btn-group">
            @for (s of StatusOptions; track s) {
              <button class="btn-filter" [class.active]="IsStatusSelected(s)"
                      [ngClass]="GetStatusClass(s)"
                      (click)="ToggleStatus(s)">{{ s }}</button>
            }
          </div>
        </div>

        <div class="filter-actions">
          <div class="auto-refresh">
            <label class="filter-label">Auto-refresh</label>
            <div class="btn-group">
              @for (opt of RefreshOptions; track opt.value) {
                <button class="btn-filter" [class.active]="AutoRefreshInterval === (opt.value || null)"
                        (click)="SetAutoRefresh(opt.value)">{{ opt.label }}</button>
              }
            </div>
          </div>
          @if (AutoRefreshInterval) {
            <i class="fa-solid fa-arrows-rotate refresh-spinner"></i>
          }
          <button class="btn-action" (click)="LoadRuns()">
            <i class="fa-solid fa-arrows-rotate"></i> Refresh
          </button>
        </div>
      </div>
    </div>

    <!-- Error -->
    @if (Error) {
      <div class="error-banner">
        <i class="fa-solid fa-circle-exclamation"></i>
        {{ Error }}
        <button (click)="Error = null">&times;</button>
      </div>
    }

    <!-- Loading -->
    @if (RunsLoading) {
      <div class="loading-overlay"><div class="spinner"></div> Loading agent runs...</div>
    }

    <!-- Results -->
    @if (!RunsLoading) {
      <div class="results-summary">
        <span class="count">{{ Runs.length }} run{{ Runs.length !== 1 ? 's' : '' }}</span>
      </div>

      <div class="table-wrapper">
        @if (Runs.length > 0) {
          <table class="runs-table">
            <thead>
              <tr>
                <th>Run ID</th>
                <th>Organization</th>
                <th>Contact</th>
                <th>Status</th>
                <th>Duration</th>
                <th>Tokens</th>
                <th>Cost</th>
                <th>Started</th>
              </tr>
            </thead>
            <tbody>
              @for (run of Runs; track run.runID) {
                <tr class="run-row" (click)="OpenRunForm(run)">
                  <td class="cell-id">
                    <span class="id-text">{{ TruncateID(run.runID) }}</span>
                    <button class="btn-copy" (click)="CopyToClipboard(run.runID, $event)" title="Copy full ID">
                      <i class="fa-solid fa-copy"></i>
                    </button>
                  </td>
                  <td class="cell-org">{{ run.organizationName || '\u2014' }}</td>
                  <td class="cell-person">{{ run.personName || '\u2014' }}</td>
                  <td>
                    <span class="status-badge" [ngClass]="GetStatusClass(run.status)">{{ run.status }}</span>
                  </td>
                  <td class="cell-duration">{{ FormatDuration(run.durationMs) }}</td>
                  <td class="cell-tokens">{{ FormatTokens(run.totalTokens) }}</td>
                  <td class="cell-cost">{{ FormatCost(run.totalCost) }}</td>
                  <td class="cell-date">{{ FormatDate(run.startedAt) }}</td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <div class="empty-state">
            <i class="fa-solid fa-inbox"></i>
            <p>No controller runs found for the selected filters.</p>
          </div>
        }
      </div>
    }
  }
</div>
